module.exports = __webpack_public_path__ + "img/ghost-avatar-white-thumb.8f8119b4.png";